import { render, staticRenderFns } from "./ChangeEventsSummaryWidget.vue?vue&type=template&id=534a6928&scoped=true&"
import script from "./ChangeEventsSummaryWidget.vue?vue&type=script&lang=js&"
export * from "./ChangeEventsSummaryWidget.vue?vue&type=script&lang=js&"
import style0 from "./ChangeEventsSummaryWidget.vue?vue&type=style&index=0&id=534a6928&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534a6928",
  null
  
)

export default component.exports